// Deal reducer

import { initializeState } from '../../../utilities/storageUtils';
import dealActionTypes from './deal.types';

const INITIAL_STATE = {
  dealData: {},
  getErrorMessage: ''
};

const dealReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);

  // Get Book information reducers
  switch (action.type) {
    // Post data request succeded
    case dealActionTypes.GET_DEAL_SUCCESS:
      return {
        ...state,
        dealData: action.dealData,
        getErrorMessage: ''
      };
    // The Post request failed
    case dealActionTypes.GET_DEAL_ERROR:
      return {
        ...state,
        dealData: {},
        getErrorMessage: action.getErrorMessage
      };

    // handle the offerCode clear event
    case dealActionTypes.CLEAR_DEAL:
      return {
        ...state,
        dealData: {}
      };

    default:
      return state;
  }
};

export default dealReducer;
